import { useCallback, useState } from "react";
import {
  PulseBeautifiedDTO,
  PulseDTO,
  PulseShootingBeautifiedDTO,
} from "../interfaces/PulseDTO";
import { ShootingsDTO } from "../interfaces/ShootingsDTO";
import axios, { AxiosResponse } from "axios";
import moment from "moment";

interface UseHeartratesReturn {
  pulse: PulseShootingBeautifiedDTO[];
  handlePulse: (
    startno?: number | null,
    shootings?: {
      [key: number]: ShootingsDTO;
    } | null
  ) => void; // You can customize this based on what handlePulse is supposed to do
}

export function useHeartrates(
  startno?: number | null,
  shootings?: {
    [key: number]: ShootingsDTO;
  } | null
): UseHeartratesReturn {
  const [pulse, setPulse] = useState<PulseShootingBeautifiedDTO[]>([]);

  const handlePulse = useCallback(
    async (startno?: number | null, shootings?: { [key: number]: ShootingsDTO } | null) => {
      if (!startno || !shootings) {
        setPulse([]);
        return;
      }
  
      let arrOfPulse: PulseShootingBeautifiedDTO[] = [];
  
      for (let key of Object.keys(shootings)) {
        const { InTime, OutTime } = shootings[parseInt(key)];
        if (InTime && OutTime) {
            let inMoment = moment(InTime); 
            let outMoment = moment(OutTime);
            let tim = inMoment.utc().format("yyyy-MM-DD HH:mm:ss");
            
            const data = await fetchData(startno, tim);
            
            if (data && data.hrHistory) {
                let arrOfpulses:PulseBeautifiedDTO[] = [];
                
                data.hrHistory.forEach((hr) => {
                    let incTime = moment(hr.timestamp);
                    
                    if (incTime.isAfter(inMoment) && incTime.isBefore(outMoment)) {
                        let diff = incTime.diff(inMoment,'seconds');
                        if (diff >= 0){
                            const pul: PulseBeautifiedDTO = {
                                heartrate: hr.hr,
                                timeprocess: diff,
                                hit: null,
                            };
                            arrOfpulses.push(pul);
                        }
                    }
                });
                
                if (arrOfpulses.length > 0){
                    let shtPuls: PulseShootingBeautifiedDTO = {
                        shootingPos: parseInt(key),
                        pulsePass: arrOfpulses,
                    };
                    arrOfPulse.push(shtPuls);
                }
            }
        }
    }
    
      setPulse(arrOfPulse);
    }, 
    []
  );
  

  const fetchData = async (
    startno: number,
    fromTime: string
  ): Promise<PulseDTO | null> => {
    try {
      const response: AxiosResponse = await axios.get(
        `https://lm85diopjl.execute-api.eu-north-1.amazonaws.com/prod/${startno}?fromTime=${fromTime}`
      );

      const responseData: PulseDTO = response.data;

      // Process the response data
      return responseData;
    } catch (error) {
      // Handle the error
      return null;
    }
  };

  return { pulse, handlePulse };
}
